import Layout from "../../components/Layout/Layout"
import MainLayoutLoader from "../../components/LayoutLoaders/MainLayoutLoader"
import { Outlet } from "react-router-dom"

export default function ProjectPageWrap() {
  return (
    <Layout isHeaderMobHidden mainLoader={<MainLayoutLoader />}>
      <Outlet />
    </Layout>
  )
}
